import { Box, Container, Dialog, Drawer, FormControl, FormControlLabel, FormLabel, Grid, IconButton, MenuItem, Modal, Radio, RadioGroup, Select, TextField, Typography, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import { storeAppointmentNotes } from '../../store/crm/appointment/notes';
import { getAppointmentcalender } from '../../store/crm/appointment';
import { useDispatch, useSelector } from 'react-redux';
import Waveloading from '../../pages/loading/Waveloading';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import SaveIcon from '@mui/icons-material/Save';
import Avatar from '@mui/material/Avatar';
import CustomButton from '../custom-button/customButton';
import { getCrmNotes } from '../../store/crm/crm/crm-details';
import { getStaff } from '../../store/crm/staffs';
import toast from 'react-hot-toast';
import BrandAvatar from '../avatar/BrandAvatar';
import { NOTE_MAX_LENGTH } from '../../utils/noteLimits';
import NoteLimitCounter from "../note-limit/NoteLimitCounter";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '92%', sm: '80%', md: '720px' },
    bgcolor: '#fff',
    borderRadius: '14px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    p: { xs: 1.5, sm: 2.5 },
    maxHeight: '90vh',
    overflowY: 'auto',
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = { 
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
const labelStyles ={
    color:'#000',
    fontSize:'16px',
    mb:'10px',
    "&.Mui-focused": {
        color:'#000!important',
    }
}
 
const AddNotesModal = ({appointmentDetails,wid,appointment,panelMode,onPanelClose,onCloseAll,externalOpen,onExternalOpenChange,hideTrigger}) => {
    const [internalOpen, setInternalOpen] = useState(false);
    const open = externalOpen !== undefined ? externalOpen : internalOpen;
    const setOpen = (val) => {
        if (onExternalOpenChange) onExternalOpenChange(val);
        if (externalOpen === undefined) setInternalOpen(val);
    };
    const handleOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); onPanelClose?.(); };
//   console.log("customer id",appointmentDetails)
    const [selectedStaff,setSelectedStaff] = useState({})
    const [loading,setLoading] = useState(false)
    const [comments,setComments] = useState('')
    const [type,setType] = useState('Medical')
//     const crmStaffStore = useSelector(state => state?.crmStaffsStore)
//     const {crmStaffs = []} = crmStaffStore 
//    //console.log(crmStaffs)

   const crmStaffStore = useSelector(state => state?.crmStaffsStore)
       const {crmStaffs = []} = crmStaffStore
    const dispatch = useDispatch()
 

    useEffect(()=>{
        (async ()=>{
            // await dispatch(getStaff())
            await dispatch(getStaff())
        })()
    },[])
    useEffect(() => {
        // Assuming you fetch your staff data here and set it to crmStaffs
        // After fetching, set the selectedStaff to the first item in the array
        if (crmStaffs && crmStaffs.length > 0) {
            setSelectedStaff(crmStaffs[0]);
        }
    }, [crmStaffs]);
    const handleSubmit = async () => {
 console.log("data",selectedStaff?.id, appointmentDetails?.id)
         setLoading(true)  
        if (comments?.length > 3 && selectedStaff?.id && appointmentDetails?.id ){
            let finalData ={
                booking_id:appointmentDetails?.id,
                staff_id:selectedStaff?.id,
                type:type,
                description:comments   
            }
           
 console.log("data",finalData)

            let res =await dispatch(storeAppointmentNotes(finalData))
          
            if (res?.payload?.success === 'true'){
    
                 dispatch(getAppointmentcalender(appointmentDetails?.id))
                 await dispatch(getCrmNotes(appointmentDetails?.customer?.id))
                 setLoading(false)
                toast.success(`${type} Note added successfully! `)
                 handleClose()
                setType('Staff')          
                setSelectedStaff({})
                setComments('')   

               
            }

        }
    }
  if (panelMode) {
    const fieldLabel = { fontSize: '13px', fontWeight: 700, color: '#1a1a2e', mb: '6px' };
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fff', position: 'relative' }}>
        {loading && <Waveloading cover />}
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', px: 2.5, py: 2, borderBottom: '1px solid #F1F2F6', flexShrink: 0, background: '#fff', gap: 1 }}>
          <IconButton size="small" onClick={onPanelClose} sx={{ color: '#A72C68', '&:hover': { background: '#FAEFF5' } }}>
            <ArrowBackIcon sx={{ fontSize: 18 }} />
          </IconButton>
          <Typography sx={{ flex: 1, fontWeight: 700, fontSize: '16px', fontFamily: 'helvetica-lt-std-bold,sans-serif', color: '#1a1a2e' }}>Add New Note</Typography>
          <IconButton size="small" onClick={onCloseAll} sx={{ color: '#9A9797', '&:hover': { color: '#EB5757', background: '#ffeaea' } }}>
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
        {(
          <Box sx={{ flex: 1, overflow: 'auto', p: 2.5 }}>
            {/* Staff Name */}
            <Box sx={{ mb: 2 }}>
              <Typography sx={fieldLabel}>Staff Name</Typography>
              <Select
                fullWidth
                size="small"
                value={selectedStaff?.id || ''}
                displayEmpty
                MenuProps={MenuProps}
                renderValue={() => selectedStaff?.id ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <BrandAvatar name={selectedStaff?.name} src={selectedStaff?.profile_image} size={24} initialsLen={1} />
                    <Typography sx={{ fontSize: '13px', color: '#1a1a2e' }}>{selectedStaff?.name}</Typography>
                  </Box>
                ) : <Typography sx={{ fontSize: '13px', color: '#9ca3af' }}>Select staff</Typography>}
                sx={{
                  borderRadius: '10px', background: '#fff',
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ECEDF2' },
                  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#E5A8C2' },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#A72C68' },
                }}
              >
                {crmStaffs?.length > 0 && crmStaffs.map((staff, key) => (
                  <MenuItem key={key} value={staff?.id} onClick={() => setSelectedStaff(staff)}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <BrandAvatar name={staff?.name} src={staff?.profile_image} size={22} initialsLen={1} />
                      <Typography sx={{ fontSize: '13px' }}>{staff?.name}</Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </Box>

            {/* Type */}
            <Box sx={{ mb: 2 }}>
              <Typography sx={fieldLabel}>Type</Typography>
              <Box sx={{ display: 'flex', gap: 1.25 }}>
                {['Medical', 'Staff'].map((t) => {
                  const isActive = type === t;
                  return (
                    <Box
                      key={t}
                      onClick={() => setType(t)}
                      sx={{
                        flex: 1,
                        display: 'flex', alignItems: 'center', gap: 1,
                        cursor: 'pointer',
                        background: isActive ? '#FAEFF5' : '#fff',
                        border: isActive ? '1.5px solid #A72C68' : '1px solid #ECEDF2',
                        borderRadius: '10px',
                        p: '10px 12px',
                        transition: 'all 0.15s',
                        '&:hover': { borderColor: '#A72C68', background: '#FAEFF5' },
                      }}
                    >
                      <Box sx={{
                        width: 18, height: 18, borderRadius: '50%',
                        border: isActive ? '5px solid #A72C68' : '2px solid #d6d8de',
                        background: '#fff',
                        flexShrink: 0,
                        transition: 'border 0.15s',
                      }} />
                      <Typography sx={{ fontSize: '13px', fontWeight: isActive ? 700 : 600, color: '#1a1a2e' }}>{t}</Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>

            {/* Notes */}
            <Box sx={{ mb: 2 }}>
              <Typography sx={fieldLabel}>Notes</Typography>
              <Box sx={{ position: 'relative', border: '1px solid #ECEDF2', borderRadius: '10px', background: '#fff', transition: 'border-color 0.15s', '&:focus-within': { borderColor: '#A72C68' } }}>
                <textarea
                  rows={6}
                  value={comments}
                  placeholder="Write your note here..."
                  maxLength={NOTE_MAX_LENGTH}
                  onChange={(e) => setComments(e.target.value)}
                  style={{ width: '100%', resize: 'vertical', padding: '10px 12px 22px', border: 'none', outline: 'none', borderRadius: '10px', fontFamily: 'inherit', fontSize: '13px', background: 'transparent', color: '#1a1a2e', boxSizing: 'border-box' }}
                />
                <NoteLimitCounter value={comments} />
              </Box>
            </Box>

            {/* Save Note */}
            <Button
              fullWidth
              variant="contained"
              startIcon={<SaveIcon sx={{ fontSize: '16px !important' }} />}
              onClick={handleSubmit}
              sx={{
                background: '#27AE60', color: '#fff',
                border: '1px solid #27AE60',
                textTransform: 'none', borderRadius: '10px', py: 1.25,
                fontWeight: 700, fontSize: '14px',
                boxShadow: 'none',
                '&:hover': { background: '#219653', color: '#fff', border: '1px solid #27AE60', boxShadow: 'none' },
              }}
            >
              Save Note
            </Button>
          </Box>
        )}
      </Box>
    );
  }

  return (

<>

{/* <CustomButtoncolor
    handleClick={handleOpen}
     mainColor={"#09ABF1"}
     size="md"
     val='Add Notes'
     style={{
      padding:'7px 5px',
      fontSize: "18px",
      minWidth:'max-content',
      borderRadius: "6px!important",
      width: "100%",
      "@media (minWidth: 420px)": {
          width: 'auto'
      },
  }}                                  
  /> */}
{!hideTrigger && (
  <Box sx={{ width:{sm:'auto', xs:wid}, textAlign:'center' }}>
    <Button
      variant="contained"
      sx={{
        background: 'linear-gradient(135deg,#A72C68 0%,#921F58 100%)',
        color: '#fff',
        textTransform: 'capitalize',
        fontWeight: 600,
        borderRadius: '10px',
        boxShadow: '0 2px 8px rgba(167,44,104,0.20)',
        px: appointment ? 2 : 4,
        width: { sm: 'auto', xs: wid },
        '&:hover': { background: 'linear-gradient(135deg,#921F58 0%,#7E1A4C 100%)' },
      }}
      onClick={handleOpen}
    >
      <TextSnippetIcon sx={{ mr: 1, fontSize: 18 }} />
      Add a Note
    </Button>
  </Box>
)}

 
    <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        keepMounted
        PaperProps={{
            sx: {
                width: { xs: '100%', sm: 480, md: 540, lg: 580 },
                maxWidth: '100vw',
                background: '#fff',
                boxShadow: '-12px 0 40px rgba(0,0,0,0.10)',
                display: 'flex',
                flexDirection: 'column',
            },
        }}
    >
        {/* Panel Header */}
        <Box sx={{
            px: { xs: 2, sm: 3 }, py: 2,
            borderBottom: '1px solid #F0CDDB',
            display: 'flex', alignItems: 'flex-start', gap: 1.5,
        }}>
            <Box sx={{
                width: 36, height: 36, borderRadius: '10px',
                background: '#FAEFF5',
                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
                <NoteAltOutlinedIcon sx={{ color: '#A72C68' }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e' }}>Add New Note</Typography>
                <Typography sx={{ fontSize: 12, color: '#6B7280', mt: 0.25 }}>Attach a medical or staff note to this appointment</Typography>
            </Box>
            <IconButton onClick={handleClose} sx={{
                width: 32, height: 32, border: '1px solid #F0CDDB', borderRadius: '8px',
                color: '#6B7280',
                '&:hover': { background: '#FAEFF5', color: '#A72C68' },
            }}>
                <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
        </Box>

        {/* Panel Body */}
        <Box sx={{
            flex: 1,
            overflowY: 'auto',
            position: 'relative',
            p: { xs: 2, sm: 3 },
            '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
                '& fieldset': { borderColor: '#F0CDDB' },
                '&:hover fieldset': { borderColor: '#A72C68' },
                '&.Mui-focused fieldset': { borderColor: '#A72C68', borderWidth: '1.5px' },
            },
            '& .MuiRadio-root': { color: '#D08CAA' },
            '& .MuiRadio-root.Mui-checked': { color: '#A72C68' },
            '& textarea.MuiInputBase-input': {
                border: '1px solid #F0CDDB !important',
                borderRadius: '10px !important',
                padding: '10px 12px !important',
                transition: 'border-color 0.15s ease',
                '&:hover': { borderColor: '#A72C68 !important' },
                '&:focus': { borderColor: '#A72C68 !important', outline: 'none' },
            },
        }}>
            {loading ? <Waveloading cover/> : ''}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <FormLabel sx={{ ...labelStyles, color: '#A72C68', fontWeight: 700, fontSize: '13px', letterSpacing: '0.04em', mb: 0.75 }}>
                            Staff Name
                        </FormLabel>
                        <Select
                            size={'small'}
                            value={selectedStaff?.id || ''}
                            displayEmpty
                            MenuProps={MenuProps}
                            sx={{
                                borderRadius: '10px',
                                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#F0CDDB' },
                                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#A72C68' },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#A72C68', borderWidth: '1.5px' },
                            }}
                        >
                            {crmStaffs?.length > 0 && crmStaffs?.map((staff, key) => (
                                <MenuItem key={key} value={staff?.id} onClick={() => setSelectedStaff(staff)}>
                                    {staff?.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <FormLabel sx={{ ...labelStyles, color: '#A72C68', fontWeight: 700, fontSize: '13px', letterSpacing: '0.04em', mb: 0.75 }}>
                            Note Type
                        </FormLabel>
                        <RadioGroup
                            row
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            sx={{ gap: 2 }}
                        >
                            <FormControlLabel value="Medical" label="Medical" control={<Radio size="small" />} />
                            <FormControlLabel value="Staff" label="Staff" control={<Radio size="small" />} />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <FormLabel sx={{ ...labelStyles, color: '#A72C68', fontWeight: 700, fontSize: '13px', letterSpacing: '0.04em', mb: 0.75 }}>
                            Notes
                        </FormLabel>
                        <textarea
                            className="MuiInputBase-input MuiOutlinedInput-input"
                            rows={5}
                            placeholder="Type your note here…"
                            maxLength={NOTE_MAX_LENGTH}
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            style={{
                                width: '100%',
                                resize: 'vertical',
                                fontFamily: 'inherit',
                                fontSize: '14px',
                                color: '#1a1a2e',
                            }}
                        />
                        <NoteLimitCounter value={comments} inline />
                    </FormControl>
                </Grid>
            </Grid>
        </Box>

        {/* Panel Footer */}
        <Box sx={{
            px: { xs: 2, sm: 3 }, py: 2,
            borderTop: '1px solid #F0CDDB',
            display: 'flex', justifyContent: 'flex-end', gap: 1,
        }}>
            <Button
                onClick={handleClose}
                sx={{
                    height: 44, px: 3, borderRadius: '10px',
                    textTransform: 'capitalize',
                    backgroundColor: '#EB5757', color: '#fff',
                    border: '1px solid #EB5757',
                    boxShadow: 'none',
                    '&:hover': { backgroundColor: '#fff', color: '#EB5757', border: '1px solid #EB5757', boxShadow: 'none' },
                }}
            >
                Cancel
            </Button>
            <Button
                onClick={handleSubmit}
                sx={{
                    height: 44, px: 3, borderRadius: '10px',
                    background: 'linear-gradient(135deg, #27AE60 0%, #1E8449 100%)',
                    color: '#fff', fontWeight: 700, fontSize: '14px',
                    border: '1px solid #27AE60',
                    textTransform: 'capitalize',
                    boxShadow: 'none',
                    '&:hover': { background: '#219653', color: '#fff', border: '1px solid #27AE60', boxShadow: 'none' },
                }}
            >
                Save Note
            </Button>
        </Box>
    </Drawer>
     </>
  )
}

export default AddNotesModal 